import { render, staticRenderFns } from "./CourseFilter.vue?vue&type=template&id=5c7918b6&scoped=true"
import script from "./CourseFilter.vue?vue&type=script&lang=js"
export * from "./CourseFilter.vue?vue&type=script&lang=js"
import style0 from "./CourseFilter.vue?vue&type=style&index=0&id=5c7918b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7918b6",
  null
  
)

export default component.exports